export class EndPoints {

  //  public static readonly BASE_URL: string ='http://smartersafeiicorpjavaspringbootmicro-env.eba-hx3uz3y2.us-east-1.elasticbeanstalk.com'
//public static readonly BASE_URL: string = "http://localhost:9002";
public static readonly BASE_URL: string ='https://uat-backend.smartersafeusa.com'
    // static PRINT_EMPLOYEE_REPORT(userId:string):string{
    //     // return this.BASE_URL+"/reports/employeeReport/"+userId;
    //     return this.BASE_URL+"/reports/employeeReport/"+userId;
    // }
    static DOWNLOAD_EMPLOYEE_REPORT_TO_EXCEL(userId:string, printedAt:string, storeName:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/employeeReportExport/"+userId+"?storeName="+encodeURIComponent(storeName)+"&printedAt="+encodeURIComponent(printedAt)
            +"&startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }
    static DOWNLOAD_EOD_REPORT_TO_EXCEL(path:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/EODReportExport/"+path
            +"?startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }

   
    // static GETINSERTBILLSREPORT(transactionNumber:string){
    //     return this.BASE_URL+"reports/employeeReportExport/"+transactionNumber;
    // }
    // static GETEODREPORT(storeName:string,toDay:boolean){
    //     return this.BASE_URL+"/reports/EODReportExport/"+storeName+"/"+toDay;
    // }
    static GETSTANDBANKREPORT(path:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/standBankReportExport/"+path
            +"?startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }
    static GETCHANGEREQUESTREPORT(path:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/changeRequestReportExport/"+path
            +"?startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }
    public static LIST_USERS(): string {
        return this.BASE_URL + "/userInfo/active/all";
    }
     static GETSTANDBANKVERIFICATIONREPORT(path:string):string{
        return this.BASE_URL+"/reports/standBank/verification/"+path
    }
    static GETSTANDBANKVERIFICATIONEXPORT(storeName:string, type:string, sDate:string, endDate:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/standBank/verification/export/"+storeName+"/"+type+"/"+sDate+"/"+endDate
            +"?startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }
    static GETSTANDBANKVERIFICATIONEXPORTBYDATE(storeName:string, type:string, sDate:string, endDate:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/standBank/verification/export/"+storeName+"/"+type+"/"+sDate+"/"+endDate
            +"?startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }
     static GETCASHPICKUPREPORT(storeName:string, sDate:string, endDate:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/cashPickupReportExport/"+storeName+"/"+sDate+"/"+endDate
            +"?startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }
    static GETWEEKLYREPORT(storeName:string, sDate:string, endDate:string, printedAt:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/weeklyReportExport/"+storeName+"/"+sDate+"/"+endDate
            +"?printedAt="+encodeURIComponent(printedAt)
            +"&startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }
    static GETOPENCLOSEREPORT(storeName:string, sDate:string, endDate:string, startTime:string, endTime:string):string{
        return this.BASE_URL+"/reports/openCloseReportExport/"+storeName+"/"+sDate+"/"+endDate
            +"?startTime="+encodeURIComponent(startTime)+"&endTime="+encodeURIComponent(endTime);
    }
}